import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, DESC_ORDER } from "@duosoftbg/nacid-components";
import { EmailNotificationFilterDetails } from "../types/emailNotificationTypes";

export const emailNotificationFilterInitialValues: EmailNotificationFilterDetails = {
  recipients: "",
  status: "",
  createdDateFrom: undefined,
  createdDateTo: undefined,
  sentDateFrom: undefined,
  sentDateTo: undefined,
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "createdDate",
};
